
//Toggle publications amount 
$('.cols__3--content__copy--downloads__toggle').click(function(){
	if ( $(this).parent().hasClass('downloads__toggle') ) {
		$(this).parent().removeClass('downloads__toggle');
	}else {
		$(this).parent().addClass('downloads__toggle');
	}
});



// WEBPACK FOOTER //
// ./src/js/publicationToggle.js